export function handleGetParams(url, params) {
    let finPath = url || '';
    const paramsArr = []; // 参数数组

    for (let key in params) {
        paramsArr.push(`${key}=${params[key]}`);
    }

    finPath = `${finPath}?${paramsArr.join("&")}`;

    return finPath;
}

export function getTime(timeStr) {
    if (!timeStr) return "-";
    
    const date = new Date(timeStr);
    // 判断日期是否合法
    if (isNaN(date.getTime())) return "-";
  
    // 直接获取 年-月-日
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
  
    return `${year}-${month}-${day}`;
  }
